import Cookies from "universal-cookie";
import axios from "axios";
import { teamAwareGet, teamAwarePost } from "../utils/teamApiHelper";

function getToken() {
    const cookies = new Cookies();
    return cookies.get("token");
}

export function onboardTeamMember(data) {
    var url = process.env.REACT_APP_API_BASE_URL + `/onboard_user`;
    return axios.post(url, data, { headers: { authorization: `Bearer ${getToken()}` } });
}

export function getTeamMembers(team_uuid = null) {
    var url = team_uuid 
        ? process.env.REACT_APP_API_BASE_URL + `/team/` + team_uuid
        : process.env.REACT_APP_API_BASE_URL + `/team/{team_uuid}`;
    return teamAwareGet(url, { headers: { authorization: `Bearer ${getToken()}` } });
}

export function getTeamStatistics(team_uuid = null) {
    var url = team_uuid
        ? process.env.REACT_APP_API_BASE_URL + `/statistics/` + team_uuid
        : process.env.REACT_APP_API_BASE_URL + `/statistics/{team_uuid}`;
    return teamAwareGet(url, { headers: { authorization: `Bearer ${getToken()}` } });
}

export function getGlobalDashboard(team_uuid = null) {
    var url = team_uuid
        ? process.env.REACT_APP_API_BASE_URL + `/team/` + team_uuid + `/dashboard`
        : process.env.REACT_APP_API_BASE_URL + `/team/{team_uuid}/dashboard`;
    return teamAwareGet(url, { headers: { authorization: `Bearer ${getToken()}` } });
}

export function updateCredits(team_uuid = null) {
    var url = team_uuid 
        ? process.env.REACT_APP_API_BASE_URL + `/get_credits/` + team_uuid
        : process.env.REACT_APP_API_BASE_URL + `/get_credits/{team_uuid}`;
    return teamAwareGet(url, { headers: { authorization: `Bearer ${getToken()}` } });
}

export function getTeamPlan(team_uuid = null) {
    var url = team_uuid 
        ? process.env.REACT_APP_API_BASE_URL + `/tier/` + team_uuid
        : process.env.REACT_APP_API_BASE_URL + `/tier/{team_uuid}`;
    return teamAwareGet(url, { headers: { authorization: `Bearer ${getToken()}` } });
}
